import { Component, OnInit } from "@angular/core";
import { LanguageService } from "src/app/core/language.service";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-login-layout",
  templateUrl: "./login-layout.component.html",
  styleUrls: ["./login-layout.component.scss"]
})
export class LoginLayoutComponent implements OnInit {
  selectedLanguage = environment.defaultLang;
  serverPath: string;

  constructor(
    private languageService: LanguageService,
    private route: ActivatedRoute
  ) {
    this.serverPath = environment.serverPath;
  }

  ngOnInit() {
    this.selectedLanguage = this.languageService.getSelectedLanguage();
  }

  selectedLanguageChanged() {
    this.languageService.changeLanguage(this.selectedLanguage);
  }
}
